import "./MyStack.scss"
import 'swiper/css';
import 'swiper/css/autoplay';


import {stack_html, stack_css, stack_scss, stack_js, stack_react, stack_node, stack_express, stack_vercel, stack_github, stack_figma, stack_mongodb, stack_wordpress, stack_ip, stack_server, stack_seo }  from "../../../service/image"

import {A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from 'swiper/react';

const MyStack = () => {


    return (
        <section id="my__stack" className="my-stack">
          <div className="container">


                <h3>My Stack</h3>
                <div className="stack__items row">
                    <div className="stack__item">
                        <div className="stack__item-el">
                        <h6>Front-end:</h6>
                        <div className="stack__slider">
                              <Swiper
                               // install Swiper modules
                               modules={[ A11y, Autoplay]}
                               spaceBetween={50}
                               slidesPerView={1}
                               loop={true}
                               autoplay={{
                                 delay: 3000,
                                 disableOnInteraction: false, 
                               }}
                               onSwiper={(swiper) => console.log(swiper)}
                               onSlideChange={() => console.log('slide change')}
                             >
                               <SwiperSlide style={{ zIndex: 1 }}> <p>HTML</p> </SwiperSlide>
                               <SwiperSlide style={{ zIndex: 1 }}> <p>CSS</p> </SwiperSlide>
                               <SwiperSlide style={{ zIndex: 1 }}> <p>SCSS</p> </SwiperSlide>
                               <SwiperSlide style={{ zIndex: 1 }}> <p>JS</p> </SwiperSlide>
                               <SwiperSlide style={{ zIndex: 1 }}> <p>REACT</p> </SwiperSlide>
                             </Swiper>
                        </div>
                        </div>

                                <div className="stack__item-el">
                                <h6>Backend:</h6>
                                <div className="stack__slider">

                                <Swiper
                                 modules={[ A11y, Autoplay]}
                                 spaceBetween={50}
                                 slidesPerView={1}
                                 loop={true}
                                 autoplay={{
                                   delay: 3000,
                                   disableOnInteraction: false, 
                                 }}
                                 onSwiper={(swiper) => console.log(swiper)}
                                 onSlideChange={() => console.log('slide change')}
                               >
                                 <SwiperSlide style={{ zIndex: 1 }}> <p>Node.js</p> </SwiperSlide>
                                 <SwiperSlide style={{ zIndex: 1 }}> <p>Express.js</p> </SwiperSlide>
                           
                               </Swiper>
                              </div>
                            </div>

                        <div className="stack__item-el">
                        <h6>Additional:</h6>
                         <div className="stack__slider">
                             <Swiper

                            modules={[ A11y, Autoplay]}
                            spaceBetween={50}
                            slidesPerView={1}
                            loop={true}
                            autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                            }}
                            onSwiper={(swiper) => console.log(swiper)}
                            onSlideChange={() => console.log('slide change')}
                          >
                            <SwiperSlide style={{ zIndex: 1 }}> <p>Vercel</p> </SwiperSlide>
                            <SwiperSlide style={{ zIndex: 1 }}> <p>GitHub</p> </SwiperSlide>
                            <SwiperSlide style={{ zIndex: 1 }}> <p>Figma</p> </SwiperSlide>
                            <SwiperSlide style={{ zIndex: 1 }}> <p>MongoDB</p> </SwiperSlide>
                            <SwiperSlide style={{ zIndex: 1 }}> <p>WordPress</p> </SwiperSlide>
                          </Swiper>
                           </div>
                        </div>
                    </div>
{/* -------------------------------------------------------------------------------------- */}
                    <div className="stack__item">
                      <div className="stack__item-el row">
                        <img src={stack_html} alt="Html icon" />
                        <img src={stack_css} alt="Css icon" />
                        <img src={stack_scss} alt="Scss icon" />
                        <img src={stack_js} alt="Js icon" />
                        <img src={stack_react} alt="React icon" />
                      </div>

                      <div className="stack__item-el row">
                        <img src={stack_node} alt="Node.js icon" />
                        <img className="stack__express-el" src={stack_express} alt="Express.js icon" />
                        <img src={stack_ip} alt="Ip icon" />
                        <img src={stack_server} alt="Server icon" />
                        <img src={stack_seo} alt="SEO icon" />


                      </div>

                      <div className="stack__item-el row">
                        <img src={stack_vercel} alt="Vercel icon" />
                        <img src={stack_github} alt="GitHub icon" />
                        <img src={stack_figma} alt="Figma icon" />
                        <img className="stack__mongo-stack" src={stack_mongodb} alt="MongoDB icon" />
                        <img src={stack_wordpress} alt="WordPress icon" />
                      </div>

                    </div>

                </div>





                </div>
        </section>
    )


}

export default MyStack